import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {OverlayService} from "../../../services/overlay/overlay.service";
import {Overlay} from "../../../services/overlay/Overlay";
declare var Yiit;

@Component({
  selector: 'app-overlays',
  templateUrl: './overlays.component.html',
  styleUrls: ['./overlays.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlaysComponent implements OnInit {

  public overlays:Overlay[];
  public Yiit = Yiit;

  constructor(
    private overlayService:OverlayService
  ) { }

  ngOnInit() {
    // update overlays from service
    this.overlayService.overlaySubject.subscribe((overlays) => {
      this.overlays = overlays.filter(overlay => overlay.isActive());
    });
  }

}
